import React, { useState, useEffect } from 'react';
import {useParams, useNavigate} from "react-router-dom"
import {useAnswerSurvey, useFetchSurveyQuestion, useSubmitCriticalIssues} from "../../hooks/api/survey/survey" 
import toast from 'react-hot-toast';
import { useUploadImageToAWS } from '../../hooks/api/utils/utils';
const MultiStepSurvey = () => {
  const navigate= useNavigate()
const submitSurveyApi= useAnswerSurvey()
  const {projectId, surveyId, locationId}= useParams()
  const userId= sessionStorage.getItem("userId")
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState({});
const [surveyAnswers, setSurveyAnswers]= useState([])
  const [surveys, setSurveys]= useState([])

  const fetchSurveys= useFetchSurveyQuestion({
    projectId, surveyId
  })

  const uploadImgToAWS= useUploadImageToAWS()
  const [currentLocation, setCurrentLocation]= useState({
    lat:0,
    long:0
  })

  function getLocation(){
    if (navigator.geolocation) {
      // Get the current position
      navigator.geolocation.getCurrentPosition(position => {
        // Get the latitude and longitude
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
    
        setCurrentLocation({lat:latitude,long:longitude})
        // Get the accuracy of the position
        const accuracy = position.coords.accuracy;
    // alert(`Latitude:${latitude}, Longitude:${longitude}`);
        // Log the position
        console.log(`Latitude: ${latitude}, Longitude: ${longitude}, Accuracy: ${accuracy}m`);
      }, error => {
        // Handle any errors
        console.error(`Error getting position: ${error.message}`);
      });
    } else {
      // Handle the case where the browser does not support geolocation
      console.log("Geolocation is not supported by this browser.");
    }
  }

  const handleAnswerChange = (questionId, value) => {
    setAnswers({ ...answers, [questionId]: value });
  };

  const handleImageChange=(file, id)=>{
    const formData= new FormData()
    formData.append("file", file)
     console.log({file})
     if(!file){
      return
     }
     uploadImgToAWS.mutate(formData, {
      onSuccess(uploadResponse){
toast.dismiss()
toast.success(`Image uploaded successfully`)
setSurveyAnswers(prev=>([...prev?.filter(x=>x.id !==id), {id, imageUrl:uploadResponse?.url}]))

      },
      onError(){
        toast.dismiss()
        toast.error(`Unable to upload Image`)
      }
     })
     

  }

  const goToNextStep = () => {
    setCurrentStep(currentStep + 1);
  console.log({surveyAnswers})
  };

  const goToPreviousStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleSubmit = () => {
console.log({currentStep,len:surveys.length})

    if(currentStep===surveys.length ){
      setCurrentStep(0)
return
    }

    setCurrentStep(prev=>currentStep + 1);


    console.log("Survey Answers:", answers);

    const response= Object.keys(answers).map(key => ({"surveyId":key, "response":answers[key], imageUrl: surveyAnswers.find(x=>x.id===key)?.imageUrl||""}))
 toast.dismiss(
 )
 toast.loading(`Submitting Survey`)
    submitSurveyApi.mutateAsync({
     userId,
     locationId,
    projectId, surveyTypeId:surveyId,
    timestamp:sessionStorage.getItem("timestamp")||"",
    location:{
      "lat":currentLocation.lat,
      "lng":currentLocation.long
    },
    response
  }, {
    onSuccess(res){
      console.log({res})
      toast.dismiss()
      toast.success(`Survey submitted successfully`)
      // navigate(`/evaluator`)
      // setAnswers({});
      // setCurrentStep(0); // Reset to the first step
    sessionStorage.removeItem("timestamp")
    },
    onError(err){
      console.log({err})
      toast.dismiss()
      toast.error(`Error submitting survey`)
    }
  })
  
    // alert("Survey submitted. Thank you!");
  
  };


  useEffect(()=>{
getLocation()
  }, [])

  const currentSurveyGroup = surveys?.[currentStep]; // Get the survey group for the current step
  const survey = surveys?.[currentStep]; // Get the survey group for the current step

useEffect(()=>{
setSurveys(fetchSurveys?.data?.surveys)
}, [fetchSurveys?.data])

if(fetchSurveys.isLoading){
return <div>Fetching surveys</div>
}

  return (
    <div className=" bg-slate-200 h-screen lg:pt-8">
    <div className="container mx-auto p-4 ">
      <h2 className="text-2xl font-bold mb-4">{currentSurveyGroup?.category}</h2>
      {currentSurveyGroup ? ( // Check if there are survey groups
        <div className="border p-4 rounded shadow-lg bg-white">
          {/* {currentSurveyGroup?.map((survey) => ( */}
            <div key={survey.id} className="mb-6">
              <p className="font-medium text-lg mb-2">{survey.question}</p>
              {survey.isComment ? (
                <textarea
                  className="w-full border rounded p-2"
                  placeholder="Enter your comments here..."
                  value={answers[survey.id] || ""}
                  onChange={(e) => handleAnswerChange(survey.id, e.target.value)}
                />
              ) : (
                <div className="flex flex-col">
                  {survey?.option?.map((option, index) => (
                    <label key={option} className="inline-flex items-center mb-2">
                      <input
                        type="radio"
                        className="form-radio mr-2"
                        name={survey.id}
                        value={survey.option[index]}
                        checked={answers[survey.id] === survey.option[index]}
                        onChange={(e) => handleAnswerChange(survey.id, e.target.value)}
                      />
                      <span>{option}</span>
                    </label>
                  ))}
                </div>
              )}

<div className="my-2 ">
            <h3>Upload Supporting Image (optional)</h3>
            <input type="file"  onChange={e=>handleImageChange(e.target.files[0], survey.id)} />
          </div>
            </div>
          {/* ))} */}

       

          <div className="flex justify-between">
            {currentStep > 0 && (
              <button
                type="button"
                onClick={goToPreviousStep}
                className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded"
              >
                Previous
              </button>
            )}

            {currentStep < surveys.length - 1 ? (
              <button
                type="button"
                disabled={uploadImgToAWS.isPending }
              onClick={goToNextStep}
                className={`${uploadImgToAWS.isPending?"bg-gray-400":"bg-blue-500 hover:bg-blue-700"} text-white font-bold py-2 px-4 rounded`}
              >
                Next
              </button>
            ) : (
              <button
                type="button"
             disabled={uploadImgToAWS.isPending}
                onClick={handleSubmit}
                className={`${uploadImgToAWS.isPending?"bg-gray-400":"bg-green-500 hover:bg-green-700 "}text-white font-bold py-2 px-4 rounded`}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      ) : currentStep===surveys?.length?
      <CriticalIssues/>
      : (
        <p>No survey questions available.</p>
      )}
    </div>
    </div>
  );
};

export default MultiStepSurvey;
const CriticalIssues = () => {
  const {projectId, surveyId, locationId}= useParams()
  const [isCriticalIssue, setIsCriticalIssue]= useState("") 
  const [criticalPayload, setCriticalPayload]= useState({
    locationId,
    projectId,
    category:"",
    message:"",
    imageUrl:"",
    surveyId

  })
  const navigate= useNavigate()
  const uploadImgToAWS= useUploadImageToAWS()
  const sumbitCriticalIssues= useSubmitCriticalIssues()
  const handleInputChange=(e)=>{
    setCriticalPayload(prev=>({...prev, [e.target.name]:e.target.value}))
  }

  const handleImageChange=(file, id)=>{
    const formData= new FormData()
    formData.append("file", file)
     console.log({file})
     if(!file){
      return
     }
     uploadImgToAWS.mutate(formData, {
      onSuccess(uploadResponse){
toast.dismiss()
toast.success(`Image uploaded successfully`)

setCriticalPayload(prev=>({...prev, image: uploadResponse.url}))
      },
      onError(){
        toast.dismiss()
        toast.error(`Unable to upload Image`)
      }
     })
     

  }

  const handleSubmit = (e) => {
  e.preventDefault()
  e.stopPropagation()
    
         toast.dismiss()
    //  toast.loading(`Submitting Survey`)

if(isCriticalIssue !=="yes"){
  toast.dismiss()
  toast.success(`Survey submitted successfully`)
navigate(`/evaluator`)
return
}

     sumbitCriticalIssues.mutate(criticalPayload, {
      onSuccess(res){
        toast.dismiss()
        toast.success(`Survey submitted successfully`)
    navigate(`/evaluator`)
      }, onError(){
        toast.dismiss()
        toast.error(`Unable to submit critical issues`)
      }
     })
      
    };

  return (
    <div className="bg-slate-200 h-screen lg:pt-8">
    <form onSubmit={handleSubmit}>
      <div className="container mx-auto p-4 md:p-6 lg:p-8">
        <h2 className="text-2xl font-bold mb-4">Critical Issues Observed</h2>

        <div className="mb-4">
          <p className="text-lg mb-2">Did you observe any critical issues during the survey?</p>
          <select
          name="isCritical"
          className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          onChange={(e)=>setIsCriticalIssue(e.target.value)}
          >
            <option value="">Select an option</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>
        <div className="mb-4">
          <p className="text-lg mb-2">If yes, select category:</p>
          <select
          name='category'
          onChange={handleInputChange}
          className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          >
            <option value="">Select an option</option>
            <option value="violence">Violence</option>
            <option value="other"></option>
          </select>
        </div>
        <div className="mb-4">
          <p className="text-lg mb-2">Additional Info</p>
          <input
            type="text"
          name="message"
          onChange={handleInputChange}
            placeholder="Enter Additional info"
            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          />
        </div>
      <div className="my-4 ">
            <h3>Upload Supporting Image (optional)</h3>
            <input type="file"  onChange={e=>handleImageChange(e.target.files[0])} />
          </div>
      </div>


      <div className=" flex justify-center">
        <button   className={`${uploadImgToAWS.isPending?"bg-gray-400":"bg-green-500 hover:bg-green-700 "}text-white font-bold py-2 px-4 rounded`}
          >Submit </button>
      </div>
      </form>
    
    </div>
  );
};
